import { ArrowLeftOutlined, BellOutlined, HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Badge, Button, Drawer, Empty, Layout } from "antd";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useNavigate, useOutletContext, useRouteLoaderData } from 'react-router-dom';
import { readNotification } from "../../api/auth/notifications.js";
import { generateRouteUrl } from "../../library/constants/routes.js";
import { Server } from "../../library/constants/server.js";
import { getTimeAgo } from "../../library/utils/intl.js";
import styles from './header.module.scss';
import notificationStyles from './notifications.module.scss';
const { Header: AntdHeader } = Layout;

const NotificationItem = ({ /* id, */ title, body, read, createdAt, onClick }) => {
  return (
    <div className={`${read ? notificationStyles.wrapperRead : notificationStyles.wrapper}`} onClick={onClick}>
      <div className={notificationStyles.title}>{title}</div>
      <div className={notificationStyles.content}>{body}</div>
      <div className={notificationStyles.footer}>{getTimeAgo(createdAt)}</div>
    </div>
  )
}

NotificationItem.propTypes = {
  // id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  read: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  createdAt: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

function Header({ title, summary, backLink = true }) {
  const [showNotifications, setShowNotifications] = useState(false);
  const { notifications, unreadCount, updateNotifications } = useOutletContext() ?? {};
  const navigate = useNavigate()
  const { user } = useRouteLoaderData('Root') || {}

  return (
    <div className="site-page-header-ghost-wrapper">
      <AntdHeader className={`header ${styles.header}`}>
        <div className="main-header">
          <div className="title-area">
            <HomeOutlined style={{ fontSize: '1.2em' }} onClick={() => { navigate(generateRouteUrl('Dashboard')) }} />  / {title && <h1>{title}</h1>} {!!summary && <div className="summary">{summary}</div>}
          </div>
          <div className="action-area">
            <div className={styles.profile}>
              {user?.profile == null ? <Avatar size={50} icon={<UserOutlined />} /> : <Avatar size={50} src={`${Server.BaseUrl}/api/v1/user/profile/${user.profile}`} />}
              <div >
                <h3 style={{ margin: "0", height: "0" }}><b>{user?.name}</b></h3>
                <h5 style={{ margin: "0", paddingTop: "20px", color: "grey" }}>Vendor</h5>
              </div>
              {/* <p>{user.role}</p> */}
            </div>
            {!!backLink && <Button type="primary" icon={<ArrowLeftOutlined />} onClick={() => navigate(backLink === true ? -1 : backLink)}>Back</Button>}
            <Badge count={unreadCount} title={`${unreadCount} unread notifications`} onClick={() => setShowNotifications(v => !v)} style={{ cursor: 'pointer' }}>
              <BellOutlined className="notifications" style={{ cursor: 'pointer' }} />
            </Badge>
          </div>
        </div>
      </AntdHeader>
      <Drawer title="Notifications" width={450} placement="right" onClose={() => setShowNotifications(false)} open={showNotifications}>
        {(Array.isArray(notifications) && notifications.length > 0) ? notifications.map(n => (
          <NotificationItem key={n.id} onClick={async () => {
            await readNotification(n.id)
            if (n.redirect) {
              const redirectUrl = n.redirect.startsWith('/') ? n.redirect : `/${n.redirect}`;
              navigate(redirectUrl)
            }
            updateNotifications()
          }} {...n} />
        )) : <Empty description="No notifications" />}
      </Drawer>
    </div>
  );
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  summary: PropTypes.string,
  backLink: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  user: PropTypes.shape({}),
};

export default Header;
